/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/directive-selector */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, Input, TemplateRef, inject } from '@angular/core';

/**
 * td Cell definition for the Appapp-dt-table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 */
@Directive({ selector: '[appDtHeaderCellDef]' })
export class DtHeaderCellDefDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);

  @Input() appDtHeaderCellDef!: string;
}

/**
 * th Cell definition for the Appapp-dt-table.
 * Captures the template of a column's data row cell as well as cell-specific properties.
 */
@Directive({ selector: '[appDtBodyCellDef]' })
export class DtBodyCellDefDirective {
  templateRef = inject<TemplateRef<any>>(TemplateRef);

  @Input() appDtBodyCellDef!: string;
}
